import React, { useState } from "react";
import Logo from "./Logo";

// =============================================================================
// Constantes de negócio
// =============================================================================
const WHATSAPP_RAW = "5515974059868"; // +55 15 97405-9868
const WHATSAPP_DISPLAY = "(15) 97405-9868";

function waLink(message) {
  return `https://wa.me/${WHATSAPP_RAW}?text=${encodeURIComponent(message)}`;
}

// =============================================================================
// Dados estáticos (definidos no handoff)
// =============================================================================
const CATEGORIAS = [
  { nome: "Motor", icon: "⚙️", desc: "Correias, velas, juntas, bombas d'água" },
  { nome: "Bomba Combustível", icon: "⛽", desc: "Bombas de gasolina, etanol, flex e diesel" },
  { nome: "Bico Injetor", icon: "💉", desc: "Bicos para injeção eletrônica, gasolina e álcool" },
  { nome: "Filtro", icon: "🧪", desc: "Ar, óleo, combustível e cabine" },
  { nome: "Outros", icon: "🔧", desc: "Outras peças sob consulta no WhatsApp" },
];

const BENEFICIOS = [
  { titulo: "Frete Rápido", desc: "Envio em até 24h úteis", icon: "🚚" },
  { titulo: "Garantia", desc: "Peças de procedência comprovada", icon: "🛡️" },
  { titulo: "Pagamento Seguro", desc: "Mercado Pago (cartão, Pix, boleto)", icon: "🔒" },
  { titulo: "Suporte Técnico", desc: "Atendimento por WhatsApp", icon: "💬" },
];

const TREINAMENTOS = [
  { titulo: "Diagnóstico de Motor", nivel: "Intermediário", duracao: "8h" },
  { titulo: "Freios ABS", nivel: "Avançado", duracao: "6h" },
  { titulo: "Injeção Eletrônica", nivel: "Intermediário", duracao: "10h" },
  { titulo: "Elétrica Automotiva", nivel: "Básico ao Avançado", duracao: "12h" },
];

const DIFERENCIAIS = [
  "Atendimento humano e consultivo pelo WhatsApp",
  "Foco em linha leve: carros, SUVs e pick-ups",
  "Pagamento seguro via Mercado Pago",
  "Envio rápido e rastreado para todo o Brasil",
  "Experiência consolidada no Mercado Livre",
];

// =============================================================================
// App principal
// =============================================================================
export default function App() {
  return (
    <div style={{ background: "var(--pan-fundo)", color: "var(--pan-texto)" }}>
      <Navbar />
      <Hero />
      <Beneficios />
      <Categorias />
      <ConsultaPeca />
      <PagamentoSeguro />
      <Treinamentos />
      <Sobre />
      <Contato />
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}

// =============================================================================
// 1. Navbar
// =============================================================================
function Navbar() {
  const [open, setOpen] = useState(false);
  const links = [
    { href: "#categorias", label: "Categorias" },
    { href: "#consulta", label: "Consulta de Peça" },
    { href: "#pagamento", label: "Pagamento" },
    { href: "#treinamentos", label: "Treinamentos" },
    { href: "#sobre", label: "Sobre" },
    { href: "#contato", label: "Contato" },
  ];

  return (
    <header
      style={{
        position: "sticky",
        top: 0,
        zIndex: 100,
        background: "rgba(28,31,38,0.92)",
        backdropFilter: "blur(8px)",
        borderBottom: "1px solid var(--pan-borda)",
      }}
    >
      <div
        className="container"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "14px 20px",
        }}
      >
        <a href="#top" aria-label="Início">
          <Logo size={42} showText stacked={false} />
        </a>

        <nav
          style={{
            display: "flex",
            alignItems: "center",
            gap: 28,
          }}
          className="nav-desktop"
        >
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              style={{
                fontSize: 14,
                fontWeight: 500,
                color: "var(--pan-texto)",
                transition: "color 0.15s",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.color = "var(--pan-azul-claro)")}
              onMouseLeave={(e) => (e.currentTarget.style.color = "var(--pan-texto)")}
            >
              {l.label}
            </a>
          ))}
          <a
            href={waLink("Olá! Vim pelo site e gostaria de um atendimento.")}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary"
          >
            <span>💬</span> WhatsApp
          </a>
        </nav>

        <button
          className="nav-mobile-toggle"
          onClick={() => setOpen((o) => !o)}
          aria-label="Abrir menu"
          style={{
            display: "none",
            background: "transparent",
            color: "white",
            fontSize: 24,
          }}
        >
          ☰
        </button>
      </div>

      {open && (
        <div
          style={{
            background: "var(--pan-fundo-card)",
            borderTop: "1px solid var(--pan-borda)",
            padding: 16,
          }}
        >
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              style={{
                display: "block",
                padding: "10px 12px",
                color: "var(--pan-texto)",
                borderBottom: "1px solid var(--pan-borda)",
              }}
            >
              {l.label}
            </a>
          ))}
          <a
            href={waLink("Olá! Vim pelo site.")}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary"
            style={{ marginTop: 12, width: "100%", justifyContent: "center" }}
          >
            💬 WhatsApp
          </a>
        </div>
      )}

      <style>{`
        @media (max-width: 860px) {
          .nav-desktop { display: none !important; }
          .nav-mobile-toggle { display: inline-block !important; }
        }
      `}</style>
    </header>
  );
}

// =============================================================================
// 2. Hero
// =============================================================================
function Hero() {
  return (
    <section
      id="top"
      style={{
        padding: "80px 20px",
        background:
          "radial-gradient(circle at 70% 30%, rgba(46,134,193,0.18), transparent 50%), " +
          "radial-gradient(circle at 20% 80%, rgba(39,174,96,0.15), transparent 50%), " +
          "var(--pan-fundo)",
      }}
    >
      <div
        className="container"
        style={{
          display: "grid",
          gridTemplateColumns: "1.2fr 1fr",
          gap: 40,
          alignItems: "center",
        }}
      >
        <div>
          <span
            style={{
              display: "inline-block",
              padding: "6px 12px",
              background: "rgba(39,174,96,0.15)",
              color: "var(--pan-verde-claro)",
              borderRadius: 20,
              fontSize: 12,
              fontWeight: 600,
              letterSpacing: "0.1em",
              textTransform: "uppercase",
              marginBottom: 20,
            }}
          >
            Linha leve · Entrega rápida
          </span>
          <h1
            style={{
              fontSize: "clamp(36px, 6vw, 60px)",
              textTransform: "uppercase",
              lineHeight: 1.05,
              marginBottom: 20,
            }}
          >
            Sua peça certa,
            <br />
            <span style={{ color: "var(--pan-verde-claro)" }}>no lugar certo.</span>
          </h1>
          <p
            style={{
              fontSize: 18,
              color: "var(--pan-texto-muted)",
              maxWidth: 540,
              marginBottom: 32,
            }}
          >
            Autopeças originais e de linha para carros, SUVs e pick-ups. Consulte
            pelo WhatsApp, pague com segurança e receba rápido em todo o Brasil.
          </p>
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
            <a
              href={waLink("Olá! Gostaria de consultar uma peça.")}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
              style={{ fontSize: 16, padding: "14px 26px" }}
            >
              💬 Consultar peça no WhatsApp
            </a>
            <a
              href="#categorias"
              className="btn btn-outline"
              style={{ fontSize: 16, padding: "14px 26px" }}
            >
              Ver categorias
            </a>
          </div>

          <div
            style={{
              display: "flex",
              gap: 32,
              marginTop: 48,
              flexWrap: "wrap",
            }}
          >
            {[
              { num: "5", label: "categorias" },
              { num: "24h", label: "para envio" },
              { num: "12x", label: "sem juros" },
              { num: "100%", label: "site seguro" },
            ].map((s) => (
              <div key={s.label}>
                <div
                  style={{
                    fontFamily: "'Rajdhani', sans-serif",
                    fontSize: 36,
                    fontWeight: 700,
                    color: "var(--pan-azul-claro)",
                    lineHeight: 1,
                  }}
                >
                  {s.num}
                </div>
                <div
                  style={{
                    fontSize: 13,
                    color: "var(--pan-texto-muted)",
                    textTransform: "uppercase",
                    letterSpacing: "0.08em",
                    marginTop: 6,
                  }}
                >
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: 20,
          }}
        >
          <div
            style={{
              background:
                "linear-gradient(135deg, rgba(46,134,193,0.1), rgba(39,174,96,0.1))",
              borderRadius: 24,
              padding: 40,
              border: "1px solid var(--pan-borda)",
            }}
          >
            <Logo size={200} showText stacked />
          </div>
        </div>
      </div>
      <style>{`
        @media (max-width: 860px) {
          #top > div { grid-template-columns: 1fr !important; text-align: center; }
          #top > div > div:last-child { display: none; }
        }
      `}</style>
    </section>
  );
}

// =============================================================================
// 3. Barra de Benefícios
// =============================================================================
function Beneficios() {
  return (
    <section
      style={{
        background: "var(--pan-fundo-card)",
        padding: "40px 20px",
        borderTop: "1px solid var(--pan-borda)",
        borderBottom: "1px solid var(--pan-borda)",
      }}
    >
      <div
        className="container"
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
          gap: 20,
        }}
      >
        {BENEFICIOS.map((b) => (
          <div
            key={b.titulo}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 14,
              padding: "10px 0",
            }}
          >
            <div
              style={{
                fontSize: 32,
                width: 54,
                height: 54,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "rgba(46,134,193,0.12)",
                borderRadius: 12,
              }}
            >
              {b.icon}
            </div>
            <div>
              <div style={{ fontWeight: 700, fontSize: 15 }}>{b.titulo}</div>
              <div style={{ fontSize: 13, color: "var(--pan-texto-muted)" }}>
                {b.desc}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

// =============================================================================
// 4. Categorias
// =============================================================================
function Categorias() {
  return (
    <section id="categorias" className="section">
      <div className="container">
        <h2 className="section-title">Categorias de autopeças</h2>
        <p className="section-sub">
          Clique na categoria para enviar uma consulta direta pelo WhatsApp — nosso
          atendimento responde com disponibilidade, prazo e preço.
        </p>
        <div
          className="grid"
          style={{
            gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
          }}
        >
          {CATEGORIAS.map((c) => {
            const msg = `Olá! Tenho interesse em peças da categoria *${c.nome}*. Pode me atender?`;
            return (
              <a
                key={c.nome}
                href={waLink(msg)}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  background: "var(--pan-fundo-card)",
                  border: "1px solid var(--pan-borda)",
                  borderRadius: 14,
                  padding: 24,
                  transition: "all 0.2s",
                  display: "flex",
                  flexDirection: "column",
                  gap: 10,
                  minHeight: 150,
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = "var(--pan-verde)";
                  e.currentTarget.style.transform = "translateY(-3px)";
                  e.currentTarget.style.boxShadow =
                    "0 10px 30px rgba(39,174,96,0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = "var(--pan-borda)";
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <div style={{ fontSize: 36 }}>{c.icon}</div>
                <div
                  style={{
                    fontFamily: "'Rajdhani', sans-serif",
                    fontSize: 22,
                    fontWeight: 700,
                    textTransform: "uppercase",
                  }}
                >
                  {c.nome}
                </div>
                <div style={{ fontSize: 13, color: "var(--pan-texto-muted)" }}>
                  {c.desc}
                </div>
                <div
                  style={{
                    marginTop: "auto",
                    fontSize: 12,
                    color: "var(--pan-verde-claro)",
                    fontWeight: 600,
                  }}
                >
                  Consultar no WhatsApp →
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}

// =============================================================================
// 5. Consulta de Peça (formulário → WhatsApp)
// =============================================================================
function ConsultaPeca() {
  const [form, setForm] = useState({ marca: "", modelo: "", ano: "", peca: "" });
  const [erro, setErro] = useState("");

  function submit(e) {
    e.preventDefault();
    if (!form.marca || !form.modelo || !form.ano || !form.peca) {
      setErro("Preencha todos os campos para enviar.");
      return;
    }
    const msg =
      `Olá! Gostaria de consultar uma peça:\n\n` +
      `🚗 *Veículo:* ${form.marca} ${form.modelo} ${form.ano}\n` +
      `🔧 *Peça:* ${form.peca}\n\n` +
      `Pode me passar disponibilidade, prazo e preço?`;
    window.open(waLink(msg), "_blank", "noopener,noreferrer");
    setErro("");
  }

  const input = {
    width: "100%",
    padding: "14px 16px",
    background: "var(--pan-fundo)",
    border: "1.5px solid var(--pan-borda)",
    borderRadius: 10,
    color: "var(--pan-texto)",
    fontSize: 15,
    fontFamily: "inherit",
    outline: "none",
    transition: "border-color 0.15s",
  };

  return (
    <section id="consulta" className="section" style={{ background: "var(--pan-fundo-card)" }}>
      <div className="container" style={{ maxWidth: 720 }}>
        <h2 className="section-title">Consulta rápida pelo WhatsApp</h2>
        <p className="section-sub">
          Preencha os dados do veículo e a peça desejada. Quando você clicar em
          enviar, abrimos uma conversa no WhatsApp com a mensagem já formatada.
        </p>

        <form
          onSubmit={submit}
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
            gap: 14,
            marginBottom: 18,
          }}
        >
          <input
            style={input}
            placeholder="Marca (ex.: Volkswagen)"
            value={form.marca}
            onChange={(e) => setForm({ ...form, marca: e.target.value })}
            onFocus={(e) => (e.target.style.borderColor = "var(--pan-azul)")}
            onBlur={(e) => (e.target.style.borderColor = "var(--pan-borda)")}
          />
          <input
            style={input}
            placeholder="Modelo (ex.: Gol)"
            value={form.modelo}
            onChange={(e) => setForm({ ...form, modelo: e.target.value })}
            onFocus={(e) => (e.target.style.borderColor = "var(--pan-azul)")}
            onBlur={(e) => (e.target.style.borderColor = "var(--pan-borda)")}
          />
          <input
            style={input}
            placeholder="Ano (ex.: 2015)"
            value={form.ano}
            onChange={(e) => setForm({ ...form, ano: e.target.value })}
            onFocus={(e) => (e.target.style.borderColor = "var(--pan-azul)")}
            onBlur={(e) => (e.target.style.borderColor = "var(--pan-borda)")}
          />
          <input
            style={{ ...input, gridColumn: "1 / -1" }}
            placeholder="Peça desejada (ex.: pastilha de freio dianteira)"
            value={form.peca}
            onChange={(e) => setForm({ ...form, peca: e.target.value })}
            onFocus={(e) => (e.target.style.borderColor = "var(--pan-azul)")}
            onBlur={(e) => (e.target.style.borderColor = "var(--pan-borda)")}
          />
        </form>

        {erro && (
          <div
            style={{
              padding: 12,
              background: "rgba(231,76,60,0.15)",
              border: "1px solid rgba(231,76,60,0.4)",
              borderRadius: 8,
              color: "#ff8a80",
              fontSize: 14,
              marginBottom: 14,
            }}
          >
            {erro}
          </div>
        )}

        <button
          type="submit"
          onClick={submit}
          className="btn btn-primary"
          style={{
            width: "100%",
            justifyContent: "center",
            padding: "16px",
            fontSize: 16,
          }}
        >
          💬 Enviar consulta pelo WhatsApp
        </button>
      </div>
    </section>
  );
}

// =============================================================================
// 6. Pagamento Seguro
// =============================================================================
function PagamentoSeguro() {
  const metodos = [
    {
      titulo: "Cartão em até 12x",
      desc: "Parcelamento sem juros* em todas as bandeiras principais.",
      icon: "💳",
    },
    { titulo: "Pix instantâneo", desc: "Pagamento aprovado na hora, com desconto.", icon: "⚡" },
    {
      titulo: "Mercado Pago",
      desc: "Ambiente 100% seguro e certificado (SSL).",
      icon: "🔒",
    },
  ];

  return (
    <section id="pagamento" className="section">
      <div className="container">
        <h2 className="section-title">Pagamento 100% seguro</h2>
        <p className="section-sub">
          Toda a transação acontece dentro do Mercado Pago (Checkout Pro). O site
          é criptografado com SSL e não armazena dados de cartão.
        </p>
        <div
          className="grid"
          style={{
            gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
          }}
        >
          {metodos.map((m) => (
            <div
              key={m.titulo}
              style={{
                background: "var(--pan-fundo-card)",
                border: "1px solid var(--pan-borda)",
                borderRadius: 14,
                padding: 28,
                textAlign: "center",
              }}
            >
              <div style={{ fontSize: 42, marginBottom: 12 }}>{m.icon}</div>
              <h3 style={{ fontSize: 20, marginBottom: 8 }}>{m.titulo}</h3>
              <p style={{ fontSize: 14, color: "var(--pan-texto-muted)" }}>{m.desc}</p>
            </div>
          ))}
        </div>

        <div
          style={{
            marginTop: 40,
            display: "flex",
            justifyContent: "center",
            gap: 16,
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              padding: "10px 16px",
              background: "rgba(39,174,96,0.15)",
              border: "1px solid rgba(39,174,96,0.4)",
              borderRadius: 20,
              fontSize: 13,
              color: "var(--pan-verde-claro)",
              fontWeight: 600,
            }}
          >
            🔒 Conexão SSL / HTTPS
          </span>
          <span
            style={{
              fontSize: 13,
              color: "var(--pan-texto-muted)",
            }}
          >
            *Parcelamento sujeito a aprovação do Mercado Pago.
          </span>
        </div>
      </div>
    </section>
  );
}

// =============================================================================
// 7. Treinamentos (EM BREVE)
// =============================================================================
function Treinamentos() {
  return (
    <section
      id="treinamentos"
      className="section"
      style={{ background: "var(--pan-fundo-card)" }}
    >
      <div className="container">
        <div style={{ textAlign: "center", marginBottom: 40 }}>
          <span
            style={{
              display: "inline-block",
              padding: "8px 18px",
              background: "linear-gradient(90deg, var(--pan-azul), var(--pan-verde))",
              color: "white",
              borderRadius: 20,
              fontSize: 12,
              fontWeight: 700,
              letterSpacing: "0.15em",
              textTransform: "uppercase",
              marginBottom: 18,
            }}
          >
            🚧 Em breve
          </span>
          <h2 className="section-title" style={{ marginBottom: 12 }}>
            Treinamentos para mecânicos
          </h2>
          <p className="section-sub" style={{ marginBottom: 0 }}>
            Cursos online gravados e agendamento de treinamentos presenciais.
            Avise-me pelo WhatsApp quando estiver disponível.
          </p>
        </div>

        <div
          className="grid"
          style={{
            gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
          }}
        >
          {TREINAMENTOS.map((t) => (
            <div
              key={t.titulo}
              style={{
                position: "relative",
                background: "var(--pan-fundo)",
                border: "1px solid var(--pan-borda)",
                borderRadius: 14,
                padding: 24,
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 14,
                  right: 14,
                  padding: "4px 10px",
                  background: "rgba(46,134,193,0.2)",
                  color: "var(--pan-azul-claro)",
                  borderRadius: 10,
                  fontSize: 10,
                  fontWeight: 700,
                  letterSpacing: "0.1em",
                }}
              >
                EM BREVE
              </div>
              <h3
                style={{
                  fontSize: 20,
                  marginBottom: 14,
                  marginRight: 80,
                  minHeight: 50,
                }}
              >
                {t.titulo}
              </h3>
              <div style={{ fontSize: 13, color: "var(--pan-texto-muted)" }}>
                Nível: <strong>{t.nivel}</strong>
              </div>
              <div style={{ fontSize: 13, color: "var(--pan-texto-muted)" }}>
                Duração: <strong>{t.duracao}</strong>
              </div>
            </div>
          ))}
        </div>

        <div style={{ textAlign: "center", marginTop: 36 }}>
          <a
            href={waLink(
              "Olá! Gostaria de ser avisado quando os treinamentos estiverem disponíveis."
            )}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary"
          >
            💬 Avise-me pelo WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}

// =============================================================================
// 8. Sobre
// =============================================================================
function Sobre() {
  return (
    <section id="sobre" className="section">
      <div
        className="container"
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 60,
          alignItems: "center",
        }}
      >
        <div>
          <h2 style={{ fontSize: "clamp(28px, 4vw, 42px)", textTransform: "uppercase", marginBottom: 20 }}>
            Sobre a <span style={{ color: "var(--pan-verde-claro)" }}>PEÇA AUTO NET</span>
          </h2>
          <p
            style={{
              fontSize: 16,
              color: "var(--pan-texto-muted)",
              marginBottom: 24,
            }}
          >
            Nascemos da experiência real consolidada no Mercado Livre, atendendo
            clientes de todo o país em autopeças para linha leve. Agora, com
            site próprio, oferecemos mais agilidade, canais diretos de
            atendimento e opções de pagamento seguras — sem deixar de lado o
            cuidado artesanal com cada pedido.
          </p>
          <ul style={{ listStyle: "none", display: "grid", gap: 10 }}>
            {DIFERENCIAIS.map((d) => (
              <li
                key={d}
                style={{ display: "flex", gap: 10, alignItems: "flex-start" }}
              >
                <span style={{ color: "var(--pan-verde)", fontWeight: 700, marginTop: 2 }}>✓</span>
                <span style={{ fontSize: 15 }}>{d}</span>
              </li>
            ))}
          </ul>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              background:
                "linear-gradient(135deg, rgba(46,134,193,0.1), rgba(39,174,96,0.1))",
              border: "1px solid var(--pan-borda)",
              borderRadius: 24,
              padding: 40,
            }}
          >
            <Logo size={180} showText stacked />
          </div>
        </div>
      </div>
      <style>{`
        @media (max-width: 860px) {
          #sobre > div { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </section>
  );
}

// =============================================================================
// 9. Contato (só WhatsApp)
// =============================================================================
function Contato() {
  return (
    <section
      id="contato"
      className="section"
      style={{
        background:
          "linear-gradient(135deg, rgba(46,134,193,0.12), rgba(39,174,96,0.12)), var(--pan-fundo)",
      }}
    >
      <div
        className="container"
        style={{
          textAlign: "center",
          maxWidth: 640,
        }}
      >
        <h2 className="section-title">Fale com a gente</h2>
        <p className="section-sub">
          O atendimento é 100% pelo WhatsApp — respondemos rápido, entendemos
          sua necessidade e te mandamos orçamento na hora.
        </p>

        <a
          href={waLink("Olá! Gostaria de mais informações.")}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-primary"
          style={{ fontSize: 18, padding: "16px 28px" }}
        >
          💬 {WHATSAPP_DISPLAY}
        </a>

        <p
          style={{
            marginTop: 24,
            fontSize: 13,
            color: "var(--pan-texto-muted)",
          }}
        >
          Atendimento de segunda a sábado. Envio rápido para todo o Brasil.
        </p>
      </div>
    </section>
  );
}

// =============================================================================
// 10. Footer
// =============================================================================
function Footer() {
  const ano = new Date().getFullYear();
  return (
    <footer
      style={{
        background: "#14161c",
        borderTop: "1px solid var(--pan-borda)",
        padding: "48px 20px 24px",
      }}
    >
      <div
        className="container"
        style={{
          display: "grid",
          gridTemplateColumns: "1.3fr 1fr 1fr 1fr",
          gap: 32,
          marginBottom: 32,
        }}
      >
        <div>
          <Logo size={60} showText stacked={false} />
          <p
            style={{
              marginTop: 14,
              fontSize: 13,
              color: "var(--pan-texto-muted)",
              maxWidth: 300,
            }}
          >
            E-commerce de autopeças para linha leve: carros, SUVs e pick-ups.
            Atendimento humano, pagamento seguro, envio rápido.
          </p>
        </div>

        <div>
          <h4 style={{ fontSize: 14, textTransform: "uppercase", marginBottom: 14, color: "var(--pan-azul-claro)" }}>
            Categorias
          </h4>
          <ul style={{ listStyle: "none", display: "grid", gap: 8, fontSize: 13 }}>
            {CATEGORIAS.slice(0, 4).map((c) => (
              <li key={c.nome}>
                <a
                  href={waLink(`Olá! Gostaria de peças de ${c.nome}.`)}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "var(--pan-texto-muted)" }}
                >
                  {c.nome}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 style={{ fontSize: 14, textTransform: "uppercase", marginBottom: 14, color: "var(--pan-azul-claro)" }}>
            Institucional
          </h4>
          <ul style={{ listStyle: "none", display: "grid", gap: 8, fontSize: 13 }}>
            <li><a href="#sobre" style={{ color: "var(--pan-texto-muted)" }}>Sobre</a></li>
            <li><a href="#pagamento" style={{ color: "var(--pan-texto-muted)" }}>Pagamento</a></li>
            <li><a href="#treinamentos" style={{ color: "var(--pan-texto-muted)" }}>Treinamentos</a></li>
            <li><a href="#contato" style={{ color: "var(--pan-texto-muted)" }}>Contato</a></li>
          </ul>
        </div>

        <div>
          <h4 style={{ fontSize: 14, textTransform: "uppercase", marginBottom: 14, color: "var(--pan-azul-claro)" }}>
            Fale conosco
          </h4>
          <a
            href={waLink("Olá! Vim do site.")}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              padding: "10px 14px",
              background: "var(--pan-verde)",
              borderRadius: 8,
              color: "white",
              fontSize: 14,
              fontWeight: 600,
            }}
          >
            💬 {WHATSAPP_DISPLAY}
          </a>
          <div style={{ marginTop: 12, fontSize: 12, color: "var(--pan-texto-muted)" }}>
            Pagamento seguro:<br />
            <strong style={{ color: "var(--pan-texto)" }}>Mercado Pago</strong> — Pix, cartão, boleto
          </div>
        </div>
      </div>

      <div
        className="container"
        style={{
          borderTop: "1px solid var(--pan-borda)",
          paddingTop: 20,
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 12,
          fontSize: 12,
          color: "var(--pan-texto-muted)",
        }}
      >
        <span>© {ano} PEÇA AUTO NET. Todos os direitos reservados.</span>
        <span>pecaautonet.com.br</span>
      </div>
      <style>{`
        @media (max-width: 860px) {
          footer > div:first-of-type { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </footer>
  );
}

// =============================================================================
// 11. WhatsApp Float
// =============================================================================
function WhatsAppFloat() {
  return (
    <a
      href={waLink("Olá! Vim pelo site da PEÇA AUTO NET.")}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Abrir conversa no WhatsApp"
      style={{
        position: "fixed",
        bottom: 24,
        right: 24,
        width: 60,
        height: 60,
        borderRadius: "50%",
        background: "#25D366",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "white",
        fontSize: 30,
        boxShadow: "0 6px 20px rgba(37,211,102,0.5)",
        zIndex: 99,
        transition: "transform 0.2s",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.08)")}
      onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
    >
      <svg
        viewBox="0 0 24 24"
        width="32"
        height="32"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
      </svg>
    </a>
  );
}
